import { render } from "./App.vue?vue&type=template&id=d0df147c&scoped=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=d0df147c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d0df147c"

export default script